<div class="flex flex-col bg-gray-50 w-full mx-auto font-prompt relative h-full overflow-hidden pb-[6.5rem]">
  <!-- 1. ส่วนหัวโค้งมนสีไล่ระดับพรีเมียม ( mockup layout header ) -->
  <div
    class="bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] pb-20 pt-8 px-6 rounded-b-[2.5rem] relative z-10 text-white text-left select-none shadow-md shrink-0">
    <!-- ปุ่มย้อนกลับ -->
    <div class="flex items-center justify-between mb-6">
      <div class="flex items-center gap-3">
        <button (click)="goBack()"
          class="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 active:scale-90 transition-all outline-none">
          <img src="icons/arrow_back_white.svg" class="w-5 h-5" />
        </button>
        <!-- ปุ่มเข้าดู Inbox คำเชิญ -->
        <button (click)="goToInbox()"
          class="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 active:scale-90 transition-all outline-none relative">
          <img src="icons/mail_white.svg" class="w-6 h-6" />
          <span *ngIf="pendingInboxCount > 0"
            class="absolute -top-1.5 -right-1.5 bg-amber-500 text-white text-[7px] font-bold rounded-full w-4 h-4 flex items-center justify-center animate-pulse">
            {{ pendingInboxCount }}
          </span>
        </button>
      </div>
      <span
        class="text-[10px] font-bold tracking-wider text-amber-400 bg-amber-500/10 px-3 py-1 rounded-full uppercase">
        {{ currentLang === "TH" ? "ข้อมูลรถยนต์" : "Vehicles" }}
      </span>
    </div>

    <!-- ข้อมูลต้อนรับส่วนตัว ( mock-up header greetings ) -->
    <div class="space-y-1">
      <span class="text-[10px] text-gray-400 font-bold uppercase tracking-wider block">{{ todayDate }}</span>
      <h1 class="text-lg font-bold leading-tight">
        {{ currentLang === "TH" ? "ทะเบียนรถของคุณ" : "Your Vehicles" }}
      </h1>
      <p class="text-[10px] text-gray-400 font-medium">
        {{ currentLang === "TH" ? "แสดงทะเบียนรถทั้งหมด เพิ่มรถ แก้ไข แชร์ และลบ ข้อมูลทะเบียน"
        : "Displays all vehicles , Add new vehicle , Edit , Share , Delete vehicle information " }}
      </p>
    </div>
  </div>

  <!-- 2. แผ่นฟอร์มแสดงรายการทับซ้อนส่วนหัว ( mockup overlapping container ) -->
  <div class="flex-1 min-h-0 px-4 relative z-20 -mt-12 select-none flex flex-col">
    <div class="bg-white rounded-[2rem] shadow-xl border border-gray-100/50 p-5 flex-1 min-h-0 flex flex-col">

      <!-- หัวข้อหัวรายการ -->
      <div class="flex items-center justify-between mb-4 pb-3 border-b border-gray-50 shrink-0">
        <span class="text-sm font-bold text-gray-700">
          {{ currentLang === "TH" ? "รายการรถยนต์ทั้งหมด" : "My Vehicles List" }}
        </span>
        <span class="text-[9px] font-bold text-amber-500 bg-amber-50 px-2 py-0.5 rounded-full">
          {{ displayVehicles.length }} {{ currentLang === "TH" ? "คัน" : "cars" }}
        </span>
      </div>

      <!-- รายการรถยนต์แต่ละคัน (แบบผสมรถตัวเอง + รถแชร์) -->
      <div class="space-y-3 flex-1 min-h-0 overflow-y-auto scroll-smooth pr-1 custom-scrollbar">
        <!-- กรณีไม่มีรายการรถ -->
        <div *ngIf="displayVehicles.length === 0" class="flex flex-col items-center justify-center py-16 text-center">
          <div
            class="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center text-gray-400 mb-3 shadow-inner">
            <img src="icons/directions_car_slate.svg" />
          </div>
          <p class="text-[11px] font-bold text-gray-400">{{ currentLang === "TH"
            ? "ยังไม่มีข้อมูลรถยนต์"
            : "No vehicles registered" }}</p>
          <p class="text-[9px] text-gray-400 mt-1">{{ currentLang === "TH"
            ? "กดปุ่มเพิ่มรถใหม่ด้านล่าง เพื่อเปิดใช้งานระบบ"
            : "Click 'Add Vehicle' below to register your first car" }}</p>
        </div>

        <!-- รายการการ์ดรถยนต์ -->
        <div *ngFor="let plan of displayVehicles"
          class="rounded-2xl p-4 border shadow-sm flex items-center justify-between transition-all hover:shadow-md duration-300"
          [ngClass]="{
            'bg-sky-50/30 border-sky-100 hover:border-sky-200': plan.isShared,
            'bg-white border-gray-100': !plan.isShared
          }">
          <!-- ส่วนข้อมูลซ้าย -->
          <div class="flex items-center gap-3 flex-1 min-w-0">
            <!-- สัญลักษณ์ไอคอนรถตามสถานะเช็ค -->
            <div class="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 transition-all duration-300"
              [ngClass]="{
                'bg-sky-100 text-sky-500': plan.isShared,
                'bg-gray-100 text-gray-400': !plan.isShared
              }">

              <img *ngIf="plan.isShared" src="icons/share_blue_soft.svg" />
              <img *ngIf="!plan.isShared" src="icons/directions_car_slate_dark.svg" />
            </div>

            <!-- รายละเอียดทะเบียนรถ -->
            <div class="text-left min-w-0 flex-1">
              <div class="flex items-center gap-1.5">
                <h3 class="text-sm font-bold text-gray-800 truncate leading-snug">{{ plan.name }}</h3>
                <span *ngIf="plan.isShared"
                  class="text-[8px] font-bold px-1.5 py-0.5 rounded bg-sky-100 text-sky-600 uppercase">
                  {{ currentLang === "TH" ? "รถแชร์" : "Shared" }}
                </span>
              </div>
              <p class="text-[9px] text-gray-400 font-bold truncate mt-0.5">
                {{ plan.province ? plan.province : (currentLang === "TH" ? "ได้รับแชร์มา" : "Shared to me") }}
                <span class="mx-1">•</span>
                {{ plan.vehicle_type_name }}
              </p>
            </div>
          </div>

          <!-- ปุ่มกระทำขวา (แก้ไข / ลบ / แชร์สิทธิ์ / ออกจากแชร์) -->
          <div class="flex items-center gap-2 flex-shrink-0 pl-2">

            <!-- กรณีที่ 1: เป็นรถของตัวเอง (เจ้าของ) -->
            <ng-container *ngIf="!plan.isShared">
              <!-- ปุ่มแก้ไขข้อมูล -->
              <button (click)="editPlan(plan)"
                class="w-7 h-7 p-1 rounded-full bg-gray-50 hover:bg-amber-50 hover:text-amber-600 text-gray-400 flex items-center justify-center transition-colors outline-none">
                <img src="icons/edit_slate_dark.svg" class="w-full h-full" />
              </button>

              <!-- ปุ่มจัดการแชร์สมาชิกกลุ่ม -->
              <button *ngIf="plan.memberCount && plan.memberCount > 0" (click)="openManageGroup(plan)"
                class="w-7 h-7 p-1 rounded-full bg-gray-50 hover:bg-amber-50 hover:text-amber-600 text-gray-400 flex items-center justify-center transition-colors outline-none relative">
                <img src="icons/group_slate_dark.svg" class="w-full h-full" />
                <span class="absolute -top-1 -right-1 bg-amber-500 text-white text-[7px] font-bold rounded-full w-3.5 h-3.5 flex items-center justify-center">
                  {{ plan.memberCount }}
                </span>
              </button>

              <!-- ปุ่มลบรถ -->
              <button (click)="deletePlan(plan)"
                class="w-7 h-7 p-1 rounded-full bg-gray-50 hover:bg-red-50 hover:text-red-600 text-gray-400 flex items-center justify-center transition-colors outline-none">
                <img src="icons/delete_slate_dark.svg" class="w-full h-full" />
              </button>
            </ng-container>

            <!-- กรณีที่ 2: เป็นรถที่ได้รับแชร์มา (สมาชิก) -->
            <ng-container *ngIf="plan.isShared">
              <!-- ปุ่มออกจากกลุ่มแชร์รถ -->
              <button (click)="leaveGroup(plan)"
                class="w-7 h-7 rounded-full bg-red-50 hover:bg-red-100 text-red-500 flex items-center justify-center transition-colors outline-none"
                title="{{ currentLang === 'TH' ? 'ออกจากกลุ่มแชร์' : 'Leave Share' }}">
                <img src="icons/logout_red.svg" />
              </button>
            </ng-container>


          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 3. ปุ่มเพิ่มทะเบียนรถใหม่ / ปุ่มแชร์รถ ลอยด้านล่างสุด ( mockup bottom layout ) -->
  <div class="fixed bottom-0 left-0 w-full px-6 py-4 bg-white border-t border-gray-100 grid grid-cols-2 gap-3 z-20">
    <button (click)="showModal_Share = true"
      class="w-full bg-slate-800 hover:bg-slate-700 text-white text-sm font-bold rounded-xl py-4 shadow-md transition-all duration-200 active:scale-95 outline-none flex items-center justify-center">
      <img class=" mr-2" src="icons/share_white.svg" />
      {{ currentLang === "TH" ? "แชร์รถยนต์" : "Share Vehicle" }}
    </button>
    <button (click)="goToAddVehicle()"
      class="w-full bg-(--main-color) hover:from-amber-600 hover:to-yellow-500 text-white text-sm font-bold rounded-xl py-4 shadow-[0_4px_12px_rgba(245,158,11,0.25)] transition-all duration-200 active:scale-95 outline-none  flex items-center justify-center">
      <img class=" mr-2" src="icons/add_white.svg" />
      {{ currentLang === "TH" ? "เพิ่มรถยนต์ใหม่" : "New Vehicle" }}
    </button>
  </div>
</div>

<!------------------------------------------ MODALS & TOASTS ------------------------------------>

<!-- หน้ากากโหลดดิ้ง -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>

<!-- MODAL SHARE VEHICLE POPUP (เด้งพิมพ์ค้นหาเพื่อแชร์ทะเบียน) -->
<app-modal-vehicle-share *ngIf="showModal_Share" [uid]="uid" [currentLang]="currentLang"
  (close)="showModal_Share = false" (success)="getMyVehicle(uid)"></app-modal-vehicle-share>

<!-- MODAL MANAGE SHARE ( จัดการกลุ่มสมาชิกในทะเบียนรถยนต์ของเรา ) -->
<div *ngIf="showModal_ManageShare && selectedGroup"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fade-in p-4">
  <div
    class="bg-white rounded-[2rem] w-full max-w-sm max-h-[80vh] overflow-y-auto px-6 pt-6 pb-8 shadow-2xl flex flex-col text-left animate-scale-up relative">
    <!-- ปุ่มปิด -->
    <button (click)="closeManageGroup()"
      class="absolute top-4 right-4 w-7 h-7 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 flex items-center justify-center transition-all active:scale-90 outline-none">
      <img src="icons/close_slate_dark.svg" class="w-full h-full" />
    </button>

    <!-- หัวข้อ -->
    <h2 class="text-sm font-bold text-gray-800 mb-4 pr-8">
      {{ currentLang === 'TH' ? 'จัดการการแชร์รถ' : 'Manage Vehicle Share' }}
    </h2>

    <div class="space-y-4 flex-grow custom-scrollbar">
      <!-- ข้อมูลรถ -->
      <div class="p-3 bg-amber-50/50 border border-amber-100/50 rounded-2xl flex items-center gap-3">
        <img src="icons/directions_car_orange.svg" />
        <div>
          <span class="text-[9px] text-gray-400 block font-bold leading-none">{{ currentLang === 'TH' ? 'ทะเบียนรถ' :
            'Plate Number' }}</span>
          <span class="text-sm font-bold text-gray-700">{{ selectedGroup.name }}</span>
        </div>
      </div>

      <!-- สมาชิกกลุ่มปัจจุบัน -->
      <div>
        <h3 class="text-sm font-bold text-gray-700 mb-2">
          {{ currentLang === 'TH' ? 'สมาชิกในกลุ่มแชร์' : 'Group Members' }}
        </h3>
        <div class="space-y-2 max-h-36 overflow-y-auto custom-scrollbar">
          <div *ngFor="let m of members"
            class="flex justify-between items-center py-2 px-3 bg-gray-50/50 border border-gray-100 rounded-xl">
            <div>
              <p class="text-sm font-bold text-gray-800">{{ m.name || '-' }}</p>
              <p class="text-[9px] text-gray-400 capitalize font-bold leading-none mt-0.5">{{ m.role }}</p>
            </div>
            <button (click)="askRevoke(m)"
              class="text-[10px] font-bold text-red-500 bg-red-50 hover:bg-red-100 px-2 py-1 rounded-lg transition-colors outline-none">
              {{ currentLang === 'TH' ? 'ถอนสิทธิ์' : 'Revoke' }}
            </button>
          </div>
          <p *ngIf="!members.length" class="text-[10px] text-gray-400 text-center py-4">
            {{ currentLang === 'TH' ? 'ยังไม่มีสมาชิกอื่นในรถคันนี้' : 'No other members in this group' }}
          </p>
        </div>
      </div>

      <!-- คิวคำเชิญที่รอส่งแชร์ (Pending Invites) -->
      <div>
        <h3 class="text-sm font-bold text-gray-700 mb-2">
          {{ currentLang === 'TH' ? 'คำเชิญที่รอการตอบรับ' : 'Pending Invitations' }}
        </h3>
        <div class="space-y-2 max-h-32 overflow-y-auto custom-scrollbar">
          <div *ngFor="let inv of pendingInvites"
            class="flex justify-between items-center py-2 px-3 bg-gray-50/50 border border-gray-100 rounded-xl">
            <div>
              <p class="text-sm font-bold text-gray-800">{{ inv.toName || ('#' + inv.toCpUserId) }}</p>
              <p class="text-[9px] text-amber-500 font-bold leading-none mt-0.5">{{ inv.status }}</p>
            </div>
            <button (click)="cancelPending(inv)"
              class="text-[10px] font-bold text-gray-400 hover:text-red-500 px-2 py-1 rounded-lg transition-colors outline-none">
              {{ currentLang === 'TH' ? 'ยกเลิก' : 'Cancel' }}
            </button>
          </div>
          <p *ngIf="!pendingInvites.length" class="text-[10px] text-gray-400 text-center py-4">
            {{ currentLang === 'TH' ? 'ไม่มีคำเชิญค้างส่ง' : 'No pending invites' }}
          </p>
        </div>
      </div>

      <!-- ปุ่มยุบกลุ่ม -->
      <div class="pt-2">
        <button (click)="askDissolve()"
          class="w-full py-2.5 rounded-xl bg-red-50 hover:bg-red-100 text-red-500 text-sm font-bold transition-all active:scale-95 outline-none">
          {{ currentLang === 'TH' ? 'ยุบกลุ่มแชร์รถยนต์นี้' : 'Dissolve Share Group' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ยืนยันการลบรถยนต์ -->
<app-pss-warn *ngIf="showModal_Delconfirm" [language]="currentLang" [isButtonConfirm]="true" [isButtonClose]="true"
  [detail]="(currentLang === 'TH' ? 'ต้องการลบรถทะเบียน' : 'Do you want to delete the vehicle') + ': ' + license + (currentLang === 'TH' ? ' ใช่ไหม?' : '?')"
  [timeIn]="3000" (submit)="deleteCar()" (close)="showModal_Delconfirm = $event"></app-pss-warn>

<!-- ยืนยันการแก้ไขรถยนต์ -->
<app-pss-warn *ngIf="showModal_Editconfirm" [language]="currentLang" [isButtonConfirm]="true" [isButtonClose]="true"
  [detail]="(currentLang === 'TH' ? 'ต้องการแก้ไขข้อมูลรถทะเบียน' : 'Do you want to edit the vehicle') + ': '+ license + (currentLang === 'TH' ? ' ใช่ไหม?' : ' ?')"
  [timeIn]="3000" (submit)="EditCar()" (close)="showModal_Editconfirm = $event"></app-pss-warn>

<!-- ยืนยันการถอนสิทธิ์สมาชิกในกลุ่มแชร์ -->
<app-pss-warn *ngIf="showConfirmRevoke" [isButtonConfirm]="true" [language]="currentLang"
  [text]="currentLang === 'TH' ? 'ถอนสมาชิก?' : 'Revoke member?'"
  [detail]="currentLang === 'TH' ? 'บัตรของสมาชิก (ถ้ามี) จะโอนกลับเจ้าของ' : 'Member cards for this plate will transfer to owner'"
  (submit)="confirmRevoke()" (close)="showConfirmRevoke = false"></app-pss-warn>

<!-- ยืนยันการยุบกลุ่มแชร์ -->
<app-pss-warn *ngIf="showConfirmDissolve" [isButtonConfirm]="true" [language]="currentLang"
  [text]="currentLang === 'TH' ? 'ยุบกลุ่มแชร์?' : 'Dissolve group?'"
  [detail]="currentLang === 'TH' ? 'หากสมาชิกยังถือบัตรรายเดือน อาจยุบไม่ได้' : 'Blocked if members still hold active monthly cards'"
  (submit)="confirmDissolve()" (close)="showConfirmDissolve = false"></app-pss-warn>